import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  cardContainer: {
    backgroundColor: "#ffffff",
    borderRadius: 20,
    padding: "24px 28px",
    boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.03)",
    marginBlock: 20,
  },
  headerTitle: {
    fontSize: "22px",
    fontWeight: 700,
    color: "#0F172A",
    fontFamily: "'Inter', sans-serif",
  },
  breadcrumbText: {
    fontSize: "14px",
    color: "#94A3B8",
    fontWeight: 500,
  },
  breadcrumbActive: {
    color: "#0F172A",
    fontWeight: 700,
    fontSize: "14px",
  },
  sectionCard: {
    backgroundColor: "#ffffff",
    border: "1px solid #E2E8F0",
    borderRadius: 16,
    padding: 24,
    height: "100%",
    display: "flex",
    flexDirection: "column",
    boxShadow: "0px 1px 3px rgba(0, 0, 0, 0.02)",
  },
  cardHeader: {
    display: "flex",
    alignItems: "center",
    gap: 12,
    marginBottom: 20,
  },
  cardIcon: {
    color: "#0F172A",
    fontSize: "22px",
  },
  cardTitle: {
    fontSize: "18px",
    fontWeight: 700,
    color: "#0F172A",
  },
  label: {
    fontSize: "13px",
    fontWeight: 600,
    color: "#475569",
    marginBottom: 6,
    display: "block",
  },
  inputField: {
    "& .MuiOutlinedInput-root": {
      backgroundColor: "#F1F5F9",
      borderRadius: 10,
      fontSize: "14px",
      fontWeight: 500,
      color: "#0F172A",
      "& fieldset": {
        borderColor: "transparent",
      },
      "&:hover fieldset": {
        borderColor: "#CBD5E1",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#94A3B8",
      },
    },
    "& .MuiSelect-select": {
      paddingBlock: "8.5px",
    },
    "& .MuiInputBase-input": {
      paddingBlock: "8.5px",
    },
  },
  toggleBox: {
    backgroundColor: "#F1F5F9",
    borderRadius: 10,
    padding: "10px 16px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  toggleBoxTitle: {
    fontSize: "14px",
    fontWeight: 600,
    color: "#0F172A",
  },
  toggleBoxSubtitle: {
    fontSize: "12px",
    color: "#64748B",
    marginTop: 2,
  },
  dropzoneBox: {
    border: "2px dashed #CBD5E1",
    borderRadius: 12,
    backgroundColor: "#F8FAFC",
    padding: 20,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: 140,
    textAlign: "center",
  },
  docIconCircle: {
    width: 44,
    height: 44,
    borderRadius: "50%",
    backgroundColor: "#E2E8F0",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "#475569",
    marginBottom: 10,
  },
  uploadBtn: {
    backgroundColor: "#000000 !important",
    color: "#ffffff !important",
    borderRadius: "20px !important",
    padding: "6px 18px !important",
    fontSize: "11px !important",
    fontWeight: "700 !important",
    letterSpacing: "0.5px !important",
    textTransform: "uppercase !important",
    boxShadow: "none !important",
    "&:hover": {
      backgroundColor: "#1E293B !important",
    },
  },
  updateBtn: {
    backgroundColor: "#000000 !important",
    color: "#ffffff !important",
    borderRadius: "10px !important",
    padding: "10px 36px !important",
    fontSize: "14px !important",
    fontWeight: "600 !important",
    textTransform: "none !important",
    boxShadow: "none !important",
    "&:hover": {
      backgroundColor: "#1E293B !important",
    },
  },
  // Upload Dialog styling
  root: {
    "& .MuiDialog-paper": {
      borderRadius: 16,
      padding: 10,
    },
  },
  dialogTitleContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  uploadAreaWrapper: {
    padding: 20,
  },
  fileUploadArea: {
    border: "2px dashed #CBD5E1",
    borderRadius: 12,
    padding: 40,
    textAlign: "center",
    cursor: "pointer",
    backgroundColor: "#F8FAFC",
  },
  fileUploadContentsStyle: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  fileIconWrapper: {
    position: "relative",
    color: "#94A3B8",
  },
  uploadIconWrapper: {
    position: "absolute",
    bottom: 5,
    right: 5,
    backgroundColor: "#0F172A",
    color: "#ffffff",
    borderRadius: "50%",
    padding: 4,
    display: "flex",
  },
  previewDocumentWrapper: {
    marginTop: 15,
    padding: 12,
    backgroundColor: "#F1F5F9",
    borderRadius: 8,
  },
  dialogActions: {
    display: "flex",
    justifyContent: "flex-end",
    gap: 10,
    padding: "10px 16px",
  },
  closeBtn: {
    "& .MuiButton-root": {
      borderRadius: 8,
    },
  },
}));

export default useStyles;
